import { useEffect } from 'react';
import { useTooltip } from '@/components/TooltipModal';

export const useTooltipCloser = (option: string) => {
  const { setActiveTooltipId } = useTooltip();

  useEffect(() => {
    setActiveTooltipId(null);
  }, [option, setActiveTooltipId]);
};
